import {http} from './api';

export const DrugsService = {
  getAutocomplete: () => http.get('drugs/autocomplete'),
};
